"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get GoogleStrategy () {
        return GoogleStrategy;
    },
    get GoogleStrategyProvider () {
        return GoogleStrategyProvider;
    }
});
const _util = require("util");
const _common = require("@nestjs/common");
const _passport = require("@nestjs/passport");
const _passportgoogleoauth20 = require("passport-google-oauth20");
const _bcryptjs = /*#__PURE__*/ _interop_require_default(require("bcryptjs"));
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
const _usersservice = require("~/services/users/users.service");
const _models = require("~/models");
const _utils = require("~/utils");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
function _ts_param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
let GoogleStrategy = class GoogleStrategy extends (0, _passport.PassportStrategy)(_passportgoogleoauth20.Strategy, 'google') {
    async validate(req, accessToken, refreshToken, profile, done) {
        // mostly copied from older code
        const email = profile.emails[0].value;
        try {
            const user = await _models.User.getByEmail(email);
            if (user) {
                // if base id defined extract base level roles
                if (req.ncBaseId) {
                    _models.BaseUser.get(req.context, req.ncBaseId, user.id).then(async (baseUser)=>{
                        user.roles = (baseUser == null ? void 0 : baseUser.roles) || user.roles;
                        // + (user.roles ? `,${user.roles}` : '');
                        done(null, (0, _utils.sanitiseUserObj)(user));
                    }).catch((e)=>done(e));
                } else {
                    return done(null, (0, _utils.sanitiseUserObj)(user));
                }
            // if user not found create new user if allowed
            // or return error
            } else {
                const salt = await (0, _util.promisify)(_bcryptjs.default.genSalt)(10);
                const user = await this.usersService.registerNewUserIfAllowed({
                    email_verification_token: null,
                    email: profile.emails[0].value,
                    password: '',
                    salt,
                    req
                });
                return done(null, (0, _utils.sanitiseUserObj)(user));
            }
        } catch (err) {
            return done(err);
        }
    }
    authorizationParams(options) {
        const params = super.authorizationParams(options);
        if (options.state) {
            params.state = options.state;
        }
        return params;
    }
    async authenticate(req, options) {
        var _process_env_NC_GOOGLE_CLIENT_ID, _process_env_NC_GOOGLE_CLIENT_SECRET;
        const googlePlugin = await _models.Plugin.getPluginByTitle('Google');
        if (googlePlugin && googlePlugin.input) {
            const settings = JSON.parse(googlePlugin.input);
            process.env.NC_GOOGLE_CLIENT_ID = settings.client_id;
            process.env.NC_GOOGLE_CLIENT_SECRET = settings.client_secret;
        }
        if (!process.env.NC_GOOGLE_CLIENT_ID || !process.env.NC_GOOGLE_CLIENT_SECRET) return this.error({
            message: 'Google client id or secret not found. Please add it in plugin settings or define env variables.'
        });
        return super.authenticate(req, _extends({}, options, {
            clientID: (_process_env_NC_GOOGLE_CLIENT_ID = process.env.NC_GOOGLE_CLIENT_ID) != null ? _process_env_NC_GOOGLE_CLIENT_ID : '',
            clientSecret: (_process_env_NC_GOOGLE_CLIENT_SECRET = process.env.NC_GOOGLE_CLIENT_SECRET) != null ? _process_env_NC_GOOGLE_CLIENT_SECRET : '',
            callbackURL: req.ncSiteUrl + _Noco.default.getConfig().dashboardPath,
            passReqToCallback: true,
            scope: [
                'profile',
                'email'
            ],
            state: req.query.state
        }));
    }
    constructor(clientConfig, usersService){
        super(clientConfig), this.usersService = usersService;
    }
};
GoogleStrategy = _ts_decorate([
    (0, _common.Injectable)(),
    _ts_param(0, (0, _common.Optional)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        Object,
        typeof _usersservice.UsersService === "undefined" ? Object : _usersservice.UsersService
    ])
], GoogleStrategy);
const GoogleStrategyProvider = {
    provide: GoogleStrategy,
    inject: [
        _usersservice.UsersService
    ],
    useFactory: async (usersService)=>{
        var _process_env_NC_GOOGLE_CLIENT_ID, _process_env_NC_GOOGLE_CLIENT_SECRET;
        // read client id and secret from env variables
        // if not found provide dummy values to avoid error
        // it will be handled in authenticate method ( reading from plugin )
        const clientConfig = {
            clientID: (_process_env_NC_GOOGLE_CLIENT_ID = process.env.NC_GOOGLE_CLIENT_ID) != null ? _process_env_NC_GOOGLE_CLIENT_ID : 'dummy-id',
            clientSecret: (_process_env_NC_GOOGLE_CLIENT_SECRET = process.env.NC_GOOGLE_CLIENT_SECRET) != null ? _process_env_NC_GOOGLE_CLIENT_SECRET : 'dummy-secret',
            // todo: update url
            callbackURL: 'http://localhost:8080/dahsboard',
            passReqToCallback: true,
            scope: [
                'profile',
                'email'
            ]
        };
        return new GoogleStrategy(clientConfig, usersService);
    }
};
